import {
  PlanService as BasePlanService,
  IFaq,
  IPlanBenefitTableDTO
} from 'react-angle-dashboard-components'

export class PlanService {
  planService: BasePlanService

  constructor(base: string) {
    this.planService = new BasePlanService(base)
  }

  getList() {
    return this.planService.getList()
  }

  getSBC(
    planId: string
  ): Promise<{ faqs: IFaq[]; events: IPlanBenefitTableDTO[] }> {
    return this.planService.getSBC(planId).then((sbc) => ({
      faqs: sbc.faqs.map((f) => ({
        title: f.question,
        description: f.answer,
        section: {
          title: 'Why this matters',
          text: f.why_this_matters
        }
      })),
      events: sbc.events
    }))
  }
}
